import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class StartScreen {
  constructor(camera, canvas) {
    this.checkbox = false;
    this.checkbox2 = false;
  }
  init() {
    this.proceeded = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    document.querySelector('#start').addEventListener('click', () => {
      if (this.isUploaded) return;
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      this.start();
    });
    document.querySelector('#checkbox').addEventListener('click', () => {
      if (this.proceeded) return;
      this.checkbox = !this.checkbox;
      if (this.checkbox) {
        document.querySelector('#checkbox').src = 'ui/Check-box-with-tick.png';
        // document.querySelector('#start').classList.add('active');
      } else {
        document.querySelector('#checkbox').src =
          'ui/Check-box-Without-tick.png';
        // document.querySelector('#start').classList.remove('active');
      }
    });
    document.querySelector('#checkbox2').addEventListener('click', () => {
      if (this.proceeded) return;
      this.checkbox2 = !this.checkbox2;
      if (this.checkbox2) {
        document.querySelector('#checkbox2').src = 'ui/Check-box-with-tick.png';
      } else {
        document.querySelector('#checkbox2').src =
          'ui/Check-box-Without-tick.png';
      }
    });
    document.querySelector('#tc').addEventListener('click', () => {
      if (this.proceeded) return;
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      Global.serverObj.send(Global.URL_VUPDATE, null, null, {
        saveType: 'privacyClick',
        uniqID: Global.U_ID,
      });
      setTimeout(() => {
        window.open(
          'https://www.kellanova.com/us/en/privacy-notice.html',
          '_blank'
        );
      }, 100);
    });
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'StartScreen') return false;

    document.querySelector('.start_screen').classList.add('active');
    gsap.delayedCall(0.0, () => {
      document.querySelector('#start_screen').classList.add('active2');
    });
    gsap.delayedCall(0.2, this.animateScreen.bind(this));
  }
  animateScreen() {
    const titleAnim = {
      value: 1,
    };
    document
      .querySelector('.start_screen .screen_container .pop')
      .classList.add('active');
    gsap.to(titleAnim, {
      value: 61,
      duration: 1.5,
      delay: 0.1,

      onUpdate: function () {
        // console.log(titleAnim.value);
        document.querySelector(
          '.start_screen .screen_container .pop'
        ).style.backgroundPosition = `0% calc(calc(100% / 61) * ${Math.floor(
          titleAnim.value
        )})`;
        // console.log(Math.round(titleAnim.value));
      }.bind(this),
      onComplete: function () {
        document
          .querySelector('.start_screen .screen_container .logo')
          .classList.add('active');
        gsap.delayedCall(0.1, () => {
          document
            .querySelector('.start_screen .screen_container .tc')
            .classList.add('active');
        });
        gsap.delayedCall(0.3, () => {
          document
            .querySelector('.start_screen .screen_container .tc2')
            .classList.add('active');
        });
        gsap.delayedCall(0.4, () => {
          document
            .querySelector('.start_screen .screen_container .btn')
            .classList.add('active');
        });
      },
      ease: 'linear',
    });
  }
  start() {
    if (this.proceeded) return;
    if (!this.checkbox) {
      document.querySelector('.errorSec').innerHTML =
        Global.lang == 'ENG'
          ? `Please accept privacy policy`
          : 'يرجى قبول سياسة الخصوصية';
      document.querySelector('.errorSec').classList.add('active');
      this.errorTO && clearTimeout(this.errorTO);
      this.errorTO = setTimeout(() => {
        document.querySelector('.errorSec').classList.remove('active');
      }, 1000);
      return false;
    }

    this.proceeded = true;
    document
      .querySelector('.start_screen .screen_container .logo')
      .classList.remove('active');
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('.start_screen .screen_container .tc')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('.start_screen .screen_container .tc2')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('.start_screen .screen_container .btn')
        .classList.remove('active');
    });
    gsap.delayedCall(0.75, () => {
      document
        .querySelector('.start_screen .screen_container .pop')
        .classList.remove('active');
    });
    if (this.checkbox2) {
      Global.serverObj.send(Global.URL_VUPDATE, null, null, {
        saveType: 'promotionsAllowed',
        uniqID: Global.U_ID,
      });
    }
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'startClick',
      uniqID: Global.U_ID,
    });
    gsap.delayedCall(1, () => {
      document.querySelector('#start_screen').classList.remove('active');
      document.querySelector('#start_screen').classList.remove('active2');
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'FormScreen',
          },
        },
      });
      // this.events.dispatchEvent({
      //   type: 'USER_EVENTS',
      //   message: {
      //     event_type: 'changeScreen',
      //     data: {
      //       curentScreen: 'start_screen',
      //       nextScreen: 'form_screen',
      //     },
      //   },
      // });
    });
  }
}
